var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"box"},[_c('a-spin',{attrs:{"spinning":_vm.loading}},[_c('div',{staticClass:"card-title"},[_vm._v(" 流量使用趋势 ")]),_c('div',{ref:"flowUsageStatisticsChart",staticClass:"chart"})])],1)}
var staticRenderFns = []

export { render, staticRenderFns }